import { create } from 'zustand'

export interface TabItem {
  objectId: string
  objectLabel: string
  recordId?: string
  path: string
}

const MAX_TABS = 10

interface TabState {
  tabs: TabItem[]
  activeTab: string | null
  openTab: (tab: TabItem) => void
  closeTab: (path: string) => void
  setActiveTab: (path: string) => void
  clearTabs: () => void
}

export const useTabStore = create<TabState>()((set, get) => ({
  tabs: [],
  activeTab: null,

  openTab: (tab) => {
    const { tabs } = get()
    const existing = tabs.find((item) => item.path === tab.path)
    if (existing) {
      set({ activeTab: tab.path })
      return
    }

    let newTabs = [...tabs]
    if (newTabs.length >= MAX_TABS) {
      const activeTab = get().activeTab
      const inactiveTabs = newTabs.filter((item) => item.path !== activeTab)
      if (inactiveTabs.length > 0) {
        newTabs = newTabs.filter((item) => item.path !== inactiveTabs[0].path)
      } else {
        newTabs = newTabs.slice(1)
      }
    }

    newTabs.push(tab)
    set({ tabs: newTabs, activeTab: tab.path })
  },

  closeTab: (path) => {
    const { tabs, activeTab } = get()
    const newTabs = tabs.filter((item) => item.path !== path)

    let newActiveTab = activeTab
    if (activeTab === path) {
      const closedIndex = tabs.findIndex((item) => item.path === path)
      if (newTabs.length > 0) {
        const nextIndex = Math.min(closedIndex, newTabs.length - 1)
        newActiveTab = newTabs[nextIndex]?.path ?? null
      } else {
        newActiveTab = null
      }
    }

    set({ tabs: newTabs, activeTab: newActiveTab })
  },

  setActiveTab: (path) => set({ activeTab: path }),

  clearTabs: () => set({ tabs: [], activeTab: null }),
}))
